import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"
import {IN_STOCK, SOLD_OUT} from "../../../../config/constants"
import {SalePrice} from "../../component"

export const PriceParentWrapper = styled("div")`
    white-space: nowrap;
`

export const StatusWrapper = styled("div")<{status: string}>`
    font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-size: ${({theme}) => `${theme.uxfabric.global.body1.fontSize}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body1.fontWeight}`};
    margin: 0.25rem 0 0 0;
    font-stretch: normal;
    font-style: normal;
    padding-top: 0.5rem;
    color: ${props => {
        switch (props.status) {
            case IN_STOCK:
                return props.theme.uxfabric.brand.success.default.textColor
            case SOLD_OUT:
                return props.theme.uxfabric.brand.error.default.textColor
            default:
                return props.theme.uxfabric.brand.warning.default.textColor
        }
    }};
`

export const ProductDetails = styled("div")`
    width: 100%;

    && > p {
        font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
        color: ${({theme}) => theme.uxfabric.text.primary};
        word-break: break-all;
        padding-right: 0.613rem;
    }
`
export const ProductDetailItem = styled("div")`
    display: flex;
    justify-content: space-between;
    > h3:first-of-type {
        word-wrap: break-word;
        max-width: 10.3125rem;
        padding-right: 0.625rem;
    }
    > h3:last-child {
        white-space: nowrap;
    }
`

export const SearchDescription = styled("h2")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-size: ${({theme}) => theme.uxfabric.global.body3.fontSize};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    margin-top: 0;
    text-transform: ${({theme}) => `${theme.uxfabric.global.body3.textTransform}`};
    line-height: ${({theme}) => `${theme.uxfabric.global.body3.lineHeight}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body3.letterSpacing}`};
    padding-right: 0.5rem;
`

export const Price = styled("p")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    font-size: ${({theme}) => `${theme.uxfabric.global.body3.fontSize}`};
    text-align: right;
    margin-top: 0;
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body3.letterSpacing}`};
    margin-right: 0.9rem;
    margin-bottom: 0rem;
`

export const SizeQuantity = styled("div")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body1.fontWeight}`};
    font-size: ${({theme}) => `${theme.uxfabric.global.body1.fontSize}`};
    color: ${({theme}) => `${theme.uxfabric.text.secondary}`};
    display: grid;
`

export const SizeQuantityText = styled("p")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body1.fontWeight}`};
    font-size: ${({theme}) => `${theme.uxfabric.global.body1.fontSize}`};
    color: ${({theme}) => `${theme.uxfabric.text.secondary}`};
    margin: 0;
    display: grid;
`

export const Title = styled("h2")`
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-size: ${({theme}) => theme.uxfabric.global.body3.fontSize};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    margin-top: 0;
    text-transform: ${({theme}) => `${theme.uxfabric.global.body3.textTransform}`};
    line-height: ${({theme}) => `${theme.uxfabric.global.body3.lineHeight}`};
    margin-bottom: 0;
`

export const SaleLabel = styled(SalePrice)`
    padding-top: 0.25rem;
    margin: 0 0.9rem 0 0;
`
